import React, { createContext, useContext, useState, useCallback } from 'react';

const RFIContext = createContext();

export function RFIProvider({ children }) {
  const [rfiStatus, setRfiStatus] = useState({
    isGenerating: false,
    isComplete: false,
    progress: 0,
    message: '',
    generatedContent: null,
    aiSuggestions: [],
  });

  const startGeneration = useCallback((message = 'Generating RFI...') => {
    setRfiStatus({
      isGenerating: true,
      isComplete: false,
      progress: 0,
      message,
      generatedContent: null,
      aiSuggestions: [],
    });
  }, []);

  const updateProgress = useCallback((progress, message) => {
    setRfiStatus(prev => ({
      ...prev,
      progress: Math.min(progress, 99),
      message: message || prev.message,
    }));
  }, []);

  const completeGeneration = useCallback((content, suggestions = []) => {
    setRfiStatus({
      isGenerating: false,
      isComplete: true,
      progress: 100,
      message: 'RFI generation complete!',
      generatedContent: content,
      aiSuggestions: suggestions,
    });
  }, []);

  const dismissNotification = useCallback(() => {
    setRfiStatus(prev => ({
      ...prev,
      isComplete: false,
    }));
  }, []);

  const resetStatus = useCallback(() => {
    setRfiStatus({
      isGenerating: false,
      isComplete: false,
      progress: 0,
      message: '',
      generatedContent: null,
      aiSuggestions: [],
    });
  }, []);

  return (
    <RFIContext.Provider value={{
      rfiStatus,
      startGeneration,
      updateProgress,
      completeGeneration,
      dismissNotification,
      resetStatus,
    }}>
      {children}
    </RFIContext.Provider>
  );
}

export function useRFI() {
  const context = useContext(RFIContext);
  if (!context) {
    throw new Error('useRFI must be used within an RFIProvider');
  }
  return context;
}
